import { Badge } from '@ordr-as/umami-react/badge';
import { Button } from '@ordr-as/umami-react/button';
import { useSearch } from '../../../context/SearchContext';
import type { LocationMenu } from '../../../types/LocationMenu';

interface SelectMenuMobileProps {
  setSelectedLocationId: (locationId: number) => void;
  selectedLocationId: number | undefined;
  locationMenus: LocationMenu[];
}

const SelectMenuMobile = (props: SelectMenuMobileProps) => {
  const { locationMenus, selectedLocationId, setSelectedLocationId } = props;
  const { searchText } = useSearch();

  return (
    <div className="flex bg-purple-lightest overflow-x-auto overflow-y-hidden">
      {locationMenus.map((locationMenu) => (
        <div key={`${locationMenu.locationId}`} className="w-full group relative justify-center pt-2">
          <Button
            onClick={() => setSelectedLocationId(locationMenu.locationId)}
            className={`px-2 mx-1 ${
              selectedLocationId === locationMenu.locationId ? 'mb-1 text-bold' : 'mb-2'
            } flex flex-row justify-between truncate text-small text-brand-secondary rounded h-6 w-full`}
          >
            <div className="flex gap-2">
              {locationMenu.locationName}
              {searchText.length !== 0 && (
                <Badge
                  text={locationMenu.sections.reduce((prev, current) => prev + current.items.length, 0).toString()}
                  className="bg-brand-white"
                />
              )}
            </div>
          </Button>
          {selectedLocationId === locationMenu.locationId && (
            <div className="px-2 flex justify-center">
              <div className="h-3 w-4 origin-bottom-left rounded-md  rotate-45 transform border border-brand-white bg-brand-white" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SelectMenuMobile;
